export enum ExportFileType {
  MACHINES_LIST = 'MACHINES_LIST',
  MACHINE_GENERAL = 'MACHINE_GENERAL',
  MACHINE_DATA = 'MACHINE_DATA',
  MACHINE_DATA_CHART = 'MACHINE_DATA_CHART',
  MACHINE_CHARTS = 'MACHINE_CHARTS',
  MACHINE_CHARTS_IN_PERIOD = 'MACHINE_CHARTS_IN_PERIOD',
  MACHINE_ALARMS_LIST = 'MACHINE_ALARMS_LIST',
  MACHINE_ALARMS_TIME_ON_VS_OFF_CHART = 'MACHINE_ALARMS_TIME_ON_VS_OFF_CHART',
  MACHINE_ALARMS_TIME_CHART = 'MACHINE_ALARMS_TIME_CHART',
  MACHINE_ALARMS_DISTRIBUTION_CHART = 'MACHINE_ALARMS_DISTRIBUTION_CHART',
  MACHINE_AUDITS_LIST = 'MACHINE_AUDITS_LIST',
  ANALYSIS_GENERAL = 'ANALYSIS_GENERAL',
  ANALYSIS_ORGANIZATIONS = 'ANALYSIS_ORGANIZATIONS',
  ANALYSIS_CONSUMPTION_AND_WORK = 'ANALYSIS_CONSUMPTION_AND_WORK',
  ANALYSIS_CONSUMPTION_AND_WORK_CHART = 'ANALYSIS_CONSUMPTION_AND_WORK_CHART',
  ANALYSIS_DISTRIBUTION_BY_COUNTRY_CHART = 'ANALYSIS_DISTRIBUTION_BY_COUNTRY_CHART',
  ANALYSIS_DISTRIBUTION_BY_STATE_CHART = 'ANALYSIS_DISTRIBUTION_BY_STATE_CHART',
  ANALYSIS_DISTRIBUTION_BY_LOCALITY_CHART = 'ANALYSIS_DISTRIBUTION_BY_LOCALITY_CHART',
  ANALYSIS_MACHINES_BY_ANTIQUITY_CHART = 'ANALYSIS_MACHINES_BY_ANTIQUITY_CHART',
  ANALYSIS_MACHINES_BY_MODEL_CHART = 'ANALYSIS_MACHINES_BY_MODEL_CHART'
}
